import styled from "@emotion/styled";

export const HeaderWrapper = styled.div`
width: 100%;
height: 60px;
pading: 10px 0px;
display: flex;
align-items: center;
`